/* ZEN 禅 Glasspad - landing sections (TENTA-X), v3: launch only.
   One controller shared by every ZEN section on the page. Page-specific; no theme files touched. */
const VERSION = '3';
window.ZEN_LP_V = VERSION;
const cl = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
const ease = (v) => (v < 0.5 ? 4 * v * v * v : 1 - Math.pow(-2 * v + 2, 3) / 2);
const sm = (a, b, v) => { const x = cl((v - a) / (b - a)); return x * x * (3 - 2 * x); };
const lerp = (a, b, k) => a + (b - a) * k;
const pad2 = (n) => String(n).padStart(2, '0');
const pinOf = (r, h) => { const tot = r.height - h; return tot > 0 ? cl(-r.top / tot) : 0; };
const viewOf = (r, vh) => cl((vh - r.top) / (vh + r.height));
const readJSON = (el) => {
  if (!el) return null;
  try { return JSON.parse(el.textContent); } catch (e) { console.error('[zen] bad JSON', e); return null; }
};

const SURFACES = [
  { id: 'ISSEN', kanji: '一閃', no: '001' },
  { id: 'SENTE', kanji: '先手', no: '002' },
  { id: 'YASHA', kanji: '夜叉', no: '003' },
];
const LABELS = {
  soldOut: 'Sold out', inStock: 'In stock', left: 'left', of: 'of', editionClosed: 'Edition closed',
  reserve: 'Reserve yours', nextEdition: 'Join the next edition', addToCart: 'Add to cart', vs: 'vs',
  errInCart: 'is already in your cart. Limit one per customer.', errAdd: 'Could not add to cart. Please try again.', errNetwork: 'Network error. Please try again.',
};
const RATINGS = [{ initial: 3, dynamic: 3, stopping: 3, clarity: 3 }, { initial: 4, dynamic: 4, stopping: 5, clarity: 5 }, { initial: 2, dynamic: 2, stopping: 2, clarity: 3 }];
const KEYS = ['initial', 'dynamic', 'stopping', 'clarity'];
const TICKS = { box: 'tickReveal', reviews: 'tickReveal', buy: 'tickBuy', hero: 'tickHero', statement: 'tickStatement', strip: 'tickStrip', details: 'tickDetails', band: 'tickBand', surfaces: 'tickSurfaces', count: 'tickCount', closing: 'tickClosing', sticky: 'tickSticky' };

class ZenHub {
  constructor() {
    this.parts = new Set();
    this.sel = 1;
    this.step = 0;
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.design = !!(window.Shopify && window.Shopify.designMode);
    const cfg = readJSON(document.querySelector('script[data-zen-data]'));
    this.hasConfig = !!cfg;
    this.setData(cfg);
    this.onResize = () => { this.scroller = this.findScroller(); this.layoutAll(); };
    this.onResize();
    window.addEventListener('resize', this.onResize, { passive: true });
    window.addEventListener('load', this.onResize, { once: true });
    document.fonts?.ready?.then(this.onResize);
    setInterval(() => { if (!this.scroller) this.scroller = this.findScroller(); }, 1500);
    /* Whatever element actually scrolls the page becomes the scroller (the theme or an app can change it). */
    document.addEventListener('scroll', (e) => {
      const t = e.target;
      if (!(t instanceof Element) || t === document.documentElement || t === document.body) {
        if ((window.scrollY || 0) > 0) this.scroller = null;
        return;
      }
      const a = this.anchor();
      if (t !== this.scroller && a && t.contains(a)) this.scroller = t;
    }, { capture: true, passive: true });
    const loop = (t) => { requestAnimationFrame(loop); this.tick(t); };
    requestAnimationFrame(loop);
    if (this.hasConfig) this.refreshStock();
  }

  setData(d) {
    const prev = this.data;
    this.data = Object.assign({ edition: 300, selected: 1, labels: {}, ratings: null, surfaces: [] }, d || {});
    this.S = SURFACES.map((b, i) => Object.assign({ variantId: 0, available: false, left: 0, total: 0, totalSrc: 'market', price: '' }, b, this.data.surfaces[i] || {}));
    this.E = Math.max(1, Number(this.data.edition) || 300);
    this.L = Object.assign({}, LABELS, this.data.labels);
    if (!prev || prev.selected !== this.data.selected) this.sel = cl(this.data.selected | 0, 0, SURFACES.length - 1);
    this.pickAvailable();
  }

  /* Without "ZEN - Product setup", read stock from the Buy area picker. */
  fromBuy(p) {
    p.querySelectorAll('.zen-pick__input').forEach((input) => {
      const x = this.S[Number(input.dataset.index)];
      if (!x) return;
      x.variantId = Number(input.value) || 0;
      x.available = input.dataset.available === 'true';
      x.left = Number(input.dataset.left) || 0;
      x.price = input.dataset.price || '';
    });
    this.pickAvailable();
  }

  attach(p) {
    if (this.parts.has(p)) this.detach(p);
    p.kind = p.dataset.part;
    p.r = {};
    p.querySelectorAll('[data-ref]').forEach((el) => { p.r[el.dataset.ref] = el; });
    p.L = readJSON(p.querySelector('script[data-zen-labels]')) || {};
    if (p.kind === 'setup') {
      const d = readJSON(p.querySelector('script[data-zen-data]'));
      if (d) { this.hasConfig = true; this.setData(d); }
      if (this.design) setTimeout(() => this.checkFiles(), 400);
    }
    if (p.kind === 'buy') {
      this.hideLeft = !!p.L.hideLeft;
      this.parts.forEach((q) => { if (q !== p) this.render(q); });
      if (!this.hasConfig) this.fromBuy(p);
      p.thumbs = [...p.querySelectorAll('[data-thumb]')];
      p.gi = 0;
      p.buyForm = p.querySelector('form.zen-buy__form');
      p._change = (e) => { if (e.target.matches('.zen-pick__input')) this.select(Number(e.target.dataset.index)); };
      p._submit = (e) => { e.preventDefault(); if (this.state === 'live') this.addToCart(e.submitter?.dataset.checkout === 'true', p); };
      p.addEventListener('change', p._change);
      p.buyForm?.addEventListener('submit', p._submit);
      const img = p.r.galImg;
      if (img) {
        p._load = () => this.fitMain(p);
        img.addEventListener('load', p._load);
        if (img.complete) this.fitMain(p);
      }
    }
    if (p.kind === 'hero') {
      p._move = (e) => { this.mouse = { x: e.clientX, y: e.clientY }; };
      p._leave = () => { this.mouse = null; };
      p.addEventListener('mousemove', p._move, { passive: true });
      p.addEventListener('mouseleave', p._leave, { passive: true });
    }
    if (p.kind === 'statement') p.words = Number(p.r.man?.dataset.words) || 30;
    if (p.kind === 'details') p.figs = p.querySelectorAll('.zen-obj__fig').length || 5;
    if (p.querySelector('[data-lamp]')) {
      p._lmove = (e) => {
        const t = e.target.closest ? e.target.closest('[data-lamp]') : null;
        if (p._lamp && p._lamp !== t) p._lamp.classList.remove('is-lamp');
        p._lamp = t;
        if (!t) return;
        const r = t.getBoundingClientRect();
        t.style.setProperty('--lx', (e.clientX - r.left).toFixed(0) + 'px');
        t.style.setProperty('--ly', (e.clientY - r.top).toFixed(0) + 'px');
        t.classList.add('is-lamp');
      };
      p._lleave = () => { if (p._lamp) p._lamp.classList.remove('is-lamp'); p._lamp = null; };
      p.addEventListener('pointermove', p._lmove, { passive: true });
      p.addEventListener('pointerleave', p._lleave, { passive: true });
    }
    p._click = (e) => this.onClick(e, p);
    p.addEventListener('click', p._click);
    this.parts.add(p);
    p.classList.add('is-on');
    if (p.kind === 'details') this.layoutGallery(p);
    if (p.kind === 'setup') this.renderAll(); else this.render(p);
  }

  detach(p) {
    if (p._lmove) { p.removeEventListener('pointermove', p._lmove); p.removeEventListener('pointerleave', p._lleave); }
    p.removeEventListener('click', p._click);
    if (p._change) p.removeEventListener('change', p._change);
    if (p._submit) p.buyForm?.removeEventListener('submit', p._submit);
    if (p._load) p.r.galImg?.removeEventListener('load', p._load);
    if (p._move) { p.removeEventListener('mousemove', p._move); p.removeEventListener('mouseleave', p._leave); }
    this.parts.delete(p);
  }

  first(kind) {
    for (const p of this.parts) if (p.kind === kind) return p;
    return null;
  }

  /* Editor only: list ZEN files that are still an older version. */
  checkFiles() {
    const box = document.querySelector('[data-zen-files]');
    if (!box) return;
    const old = [];
    document.querySelectorAll('zen-section').forEach((el) => { if (el.dataset.v !== VERSION) old.push(`sections/001-Zen-${el.dataset.part}.liquid`); });
    const any = document.querySelector('zen-section');
    if (any && getComputedStyle(any).getPropertyValue('--zen-css-v').trim() !== VERSION) old.push('assets/001-Zen-landing.css');
    if (!document.querySelector(`script[src*="001-Zen-landing.js"][data-zen-v="${VERSION}"]`)) old.push('snippets/001-Zen-assets.liquid');
    box.textContent = old.length ? `Old files still installed: ${[...new Set(old)].join(', ')}` : `Files: all v${VERSION}`;
  }

  /* The theme scrolls inside .page-wrapper on desktop, the window on mobile. */
  findScroller() {
    const pw = document.querySelector('.page-wrapper');
    if (pw) {
      const oy = getComputedStyle(pw).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && pw.scrollHeight > pw.clientHeight + 1) return pw;
    }
    return null;
  }
  get scrollTop() {
    if (this.scroller) return this.scroller.scrollTop;
    if (this._pw === undefined) this._pw = document.querySelector('.page-wrapper');
    return Math.max(window.scrollY || 0, document.documentElement.scrollTop || 0, document.body.scrollTop || 0, this._pw ? this._pw.scrollTop : 0);
  }
  anchor() {
    for (const p of this.parts) if (p.kind !== 'sticky') return p;
    return null;
  }
  get viewH() { return this.scroller ? this.scroller.clientHeight : window.innerHeight; }
  scrollToY(top) { (this.scroller || window).scrollTo({ top: Math.max(0, top), behavior: this.reduced ? 'auto' : 'smooth' }); }
  absTop(el) {
    const base = this.scroller ? this.scroller.getBoundingClientRect().top : 0;
    return el.getBoundingClientRect().top - base + this.scrollTop;
  }
  headerOffset() { return parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0; }
  scrollToEl(el) {
    if (!el) return;
    const top = this.absTop(el);
    this.scrollToY(top < this.scrollTop ? top - this.headerOffset() : top);
  }
  /* End of the page content: the footer starts right after it. (A hidden footer-group section, e.g. a popup, must not count.) */
  footerEl() {
    if (this._footer === undefined) this._footer = document.querySelector('main#MainContent') || document.querySelector('main') || document.getElementById('MainContent') || null;
    return this._footer;
  }

  layoutAll() {
    this.parts.forEach((p) => {
      if (p.kind === 'details') this.layoutGallery(p);
      if (p.kind === 'count') this.sizeTicks(p);
    });
  }

  /* Sideways track on desktop; a stacked list on phones and with reduced motion. */
  layoutGallery(p) {
    const gal = p.r.gal, tr = p.r.galTrack;
    if (!gal || !tr) return;
    const track = !this.reduced && window.innerWidth >= 750;
    gal.classList.toggle('is-track', track);
    if (!track) { gal.style.height = ''; tr.style.transform = ''; p.galDist = 0; return; }
    const vw = p.r.galViewport?.clientWidth || window.innerWidth;
    p.galDist = Math.max(0, tr.scrollWidth - vw);
    const want = Math.round(p.galDist + (p.r.galViewport?.clientHeight || this.viewH));
    if (Math.abs(gal.offsetHeight - want) > 2) gal.style.height = want + 'px';
  }

  /* About 4 px per mark, so the stock bar never turns into a solid block on phones. */
  sizeTicks(p) {
    const ed = p.r.ed, bar = p.querySelector('.zen-ed__bar');
    if (!ed || !bar || !bar.clientWidth) return;
    const n = Math.max(10, Math.min(this.E, Math.floor(bar.clientWidth / 4)));
    if (p._n !== n) { p._n = n; ed.style.setProperty('--ed-n', n); }
  }

  fitMain(p) {
    const img = p.r.galImg, box = img?.parentElement;
    if (!img || !box || !img.naturalWidth) return;
    box.style.setProperty('--zen-ar', cl(img.naturalWidth / img.naturalHeight, 0.8, 1.9).toFixed(4));
  }

  get state() { return this.S.some((s) => s.available) ? 'live' : 'sold'; }

  pickAvailable() {
    if (this.S[this.sel]?.available) return;
    const i = this.S.findIndex((x) => x.available);
    if (i >= 0) this.sel = i;
  }

  /* Shopify can serve a saved copy of the page; re-render "ZEN - Product setup" fresh so stock is always current. */
  async refreshStock() {
    const url = (this.data.productUrl || '').split('?')[0];
    const sid = this.data.sectionId;
    if (!url || !sid) return;
    try {
      const html = await fetch(url + '?section_id=' + encodeURIComponent(sid) + '&_=' + Date.now(), { cache: 'no-store' }).then((r) => (r.ok ? r.text() : ''));
      const m = html.match(/<script[^>]*data-zen-data[^>]*>([\s\S]*?)<\/script>/);
      if (!m) return;
      (JSON.parse(m[1]).surfaces || []).forEach((f, i) => {
        const x = this.S[i];
        if (!x || f.id !== x.id) return;
        x.variantId = f.variantId || x.variantId;
        x.available = !!f.available;
        x.left = f.left;
        if (f.total != null) x.total = f.total;
        if (f.soon != null) x.soon = !!f.soon;
        if (f.totalSrc) x.totalSrc = f.totalSrc;
        if (f.price) x.price = f.price;
      });
      this.pickAvailable();
      this.renderAll();
    } catch (e) { /* keep page values */ }
  }

  /* Edition count: stock across all locations when the custom.total_stock metafield is set, otherwise the visitor's market. */
  edLeft(x, f) {
    if (f != null) return Math.min(this.E, Math.max(0, f));
    if (x.totalSrc === 'mf') return x.total > 0 ? x.total : 0;
    return x.available ? (x.left > 0 ? x.left : this.E) : 0;
  }
  edText(x, f) {
    const L = this.L;
    if (f != null) return f > 0 ? `${Math.min(this.E, f)} ${L.of} ${this.E} ${L.left}` : this.outText(x);
    if (x.totalSrc === 'mf') return x.total > 0 ? `${x.total} ${L.of} ${this.E} ${L.left}` : this.outText(x);
    return this.leftText(x, true, true);
  }

  /* What a surface shows when it can't be bought: "Sold out", or "Coming soon" if set in ZEN - Product setup. */
  outText(x) { return x && x.soon ? (this.L.soon || 'Coming soon') : this.L.soldOut; }

  leftText(x, long, always) {
    const L = this.L;
    if (!x.available) return this.outText(x);
    if (!(x.left > 0) || (this.hideLeft && !always)) return L.inStock;
    return long ? `${x.left} ${L.of} ${this.E} ${L.left}` : `${x.left} ${L.left}`;
  }

  ratings() { return this.data.ratings || RATINGS; }

  hasPrice(p) { return !!p && /[1-9]/.test(p); }

  renderAll() { this.parts.forEach((p) => this.render(p)); }

  render(p) {
    const st = this.state, S = this.S, E = this.E;
    const s = S[this.sel] || S[0];
    const L = Object.assign({}, this.L, p.L);
    const live = st === 'live';
    const out = live && !s.available;
    const price = this.hasPrice(s.price) ? s.price : '';
    const sep = L.sep ?? '·';
    const J = (a, b) => (sep ? `${a} ${sep} ${b}` : `${a} ${b}`);
    const jn = (arr) => arr.join(sep ? ` ${sep} ` : ' ');
    const set = (k, v) => {
      const t = String(v);
      p.querySelectorAll(`[data-bind="${k}"]`).forEach((el) => { if (el.textContent !== t) el.textContent = t; });
    };
    p.dataset.state = st;
    p.querySelectorAll('[data-show]').forEach((el) => { el.hidden = !el.dataset.show.split(' ').includes(st); });
    /* Edition count with the Total stock field: shown from the all-country total, not the visitor's country. */
    if (p.querySelector('[data-ed]')) {
      const F = p.L.edFixed || [];
      const allGone = this.S.every((x, i) => (F[i] != null ? !(F[i] > 0) : !(x.totalSrc === 'mf' && x.total > 0)));
      p.querySelectorAll('[data-ed="rows"]').forEach((el) => { el.hidden = allGone; });
      p.querySelectorAll('[data-ed="sold"]').forEach((el) => { el.hidden = !allGone; });
    }

    set('surf-id', s.id);
    set('surf-kanji', s.kanji);
    p.querySelectorAll('[data-surf-logo]').forEach((el) => { el.hidden = Number(el.dataset.surfLogo) !== this.sel; });
    set('edition', E);
    set('price', price);
    set('cta-right', price);
    set('hero-status', live ? J(s.id, this.leftText(s, true)) : L.editionClosed);
    set('hero-cta', live ? (out ? J(s.id, this.outText(s)) : price ? J(L.reserve, price) : L.reserve) : L.nextEdition);
    set('status', live ? J(s.id, this.leftText(s, true)) : L.soldOut);
    set('cta-label', out ? J(s.id, this.outText(s)) : L.addToCart);
    set('sticky-label', out ? this.outText(s) : L.addToCart);

    p.querySelectorAll('[data-buy-btn]').forEach((b) => { b.disabled = !live || out || !!this._busy; });
    if (p.r.stickyBtn) p.r.stickyBtn.disabled = !live || out || !!this._busy;

    p.querySelectorAll('.zen-pick__input').forEach((input) => { input.checked = Number(input.dataset.index) === this.sel; });
    p.querySelectorAll('.zen-pick').forEach((el) => el.classList.toggle('is-active', Number(el.dataset.index) === this.sel));

    S.forEach((x, i) => {
      set(`left-${i}`, this.leftText(x, false));
      const fx = (p.L.edFixed || [])[i];
      set(`ed-left-${i}`, this.edText(x, fx));
      const fill = p.querySelector(`[data-ed-fill="${i}"]`);
      if (fill) {
        const left = this.edLeft(x, fx);
        fill.style.setProperty('--pct', (((E - left) / E) * 100).toFixed(2));
      }
    });

    if (p.r.focus) {
      const RR = this.ratings();
      const tr = (p.L.traits || [])[this.sel];
      set('focus-title', tr ? J(s.id, tr) : s.id);
      set('focus-vs', `${L.vs || 'vs'} ${jn(S.filter((_, i) => i !== this.sel).map((o) => o.id))}`);
      p.r.focus.querySelectorAll('.zen-focus__row[data-m]').forEach((row) => {
        const key = KEYS[Number(row.dataset.m)];
        const v = RR[this.sel]?.[key] ?? 0;
        row.style.setProperty('--pct', v * 20);
        const ve = row.querySelector('[data-focus-val]');
        if (ve && ve.textContent !== String(v)) ve.textContent = v;
        const groups = {};
        S.forEach((o, i) => { if (i === this.sel) return; const ov = RR[i]?.[key] ?? 0; (groups[ov] = groups[ov] || []).push(o.id); });
        const entries = Object.entries(groups);
        row.querySelectorAll('[data-ghost]').forEach((g, gi) => {
          const e = entries[gi];
          g.hidden = !e;
          if (!e) return;
          g.style.setProperty('--g', Number(e[0]) * 20);
          const lb = g.querySelector('.zen-focus__ghost-label');
          if (lb) lb.textContent = jn(e[1]);
        });
      });
    }
    {
      const RR = this.ratings();
      p.querySelectorAll('.zen-meter__val [data-s]').forEach((el) => { const v = RR[el.dataset.s]?.[KEYS[el.dataset.m]]; if (v != null && el.textContent !== String(v)) el.textContent = v; });
    }
    if (p.kind === 'count') this.sizeTicks(p);
    this.renderStep(p);
  }

  renderStep(p) {
    p.querySelectorAll('[data-step-logo]').forEach((el) => { el.hidden = Number(el.dataset.stepLogo) !== this.step; });
    const s = this.S[this.step];
    if (!s) return;
    p.querySelectorAll('[data-bind="step-id"]').forEach((el) => { if (el.textContent !== s.id) el.textContent = s.id; });
    p.querySelectorAll('[data-bind="step-kanji"]').forEach((el) => { if (el.textContent !== s.kanji) el.textContent = s.kanji; });
  }

  select(i) {
    if (!this.S[i]) return;
    this.sel = i;
    this.showError('');
    this.renderAll();
    const b = this.first('buy');
    const mid = b?.querySelector(`.zen-pick__input[data-index="${i}"]`)?.dataset.media;
    if (b && mid && mid !== '0') {
      const t = (b.thumbs || []).find((x) => x.dataset.mediaId === mid);
      if (t) this.setImg(b, Number(t.dataset.thumb));
    }
  }

  setImg(p, i) {
    const n = p.thumbs?.length, img = p.r.galImg;
    if (!n || !img) return;
    p.gi = (i + n) % n;
    const t = p.thumbs[p.gi];
    img.srcset = t.dataset.srcset || '';
    img.src = t.dataset.src;
    img.alt = t.dataset.alt || '';
    p.thumbs.forEach((b, k) => b.classList.toggle('is-active', k === p.gi));
    if (p.r.galCounter) p.r.galCounter.textContent = `${pad2(p.gi + 1)} / ${pad2(n)}`;
  }

  jumpTo(i) {
    const el = this.first('surfaces')?.r.surf;
    if (!el) return;
    const tot = el.offsetHeight - (el.firstElementChild?.clientHeight || this.viewH);
    this.scrollToY(this.absTop(el) + tot * ((i + 0.5) / 3));
  }

  goBuy(focusNotify) {
    const b = this.first('buy');
    if (!b) return false;
    this.scrollToEl(b.r.buy || b);
    if (focusNotify) setTimeout(() => b.querySelector('.zen-notify__input')?.focus({ preventScroll: true }), 750);
    return true;
  }

  goSurfaces() {
    const s = this.first('surfaces');
    if (s) return this.scrollToEl(s.r.surf || s);
    this.scrollToEl(this.first('buy')?.querySelector('.zen-focus'));
  }

  onClick(e, p) {
    const a = e.target.closest('[data-action],[data-thumb],[data-select],[data-jump]');
    if (!a || !p.contains(a)) return;
    if (a.dataset.thumb != null) return this.setImg(p, Number(a.dataset.thumb));
    if (a.dataset.select != null) return this.select(Number(a.dataset.select));
    if (a.dataset.jump != null) return this.jumpTo(Number(a.dataset.jump));
    const live = this.state === 'live';
    switch (a.dataset.action) {
      case 'primary':
        e.preventDefault();
        if (!this.goBuy(!live) && live) this.addToCart(false, p);
        return;
      case 'specs': a.setAttribute('aria-expanded', a.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'); return;
      case 'rev': e.preventDefault(); return this.revPlay(p, Number(a.dataset.i) || 0, a);
      case 'buy': e.preventDefault(); return this.goBuy(false);
      case 'surfaces': e.preventDefault(); return this.goSurfaces();
      case 'prev': return this.setImg(p, p.gi - 1);
      case 'next': return this.setImg(p, p.gi + 1);
      case 'choose': this.select(this.step); return this.goBuy(false);
      case 'sticky': if (live) this.addToCart(false, p); return;
    }
  }

  showError(msg) {
    const el = this.first('buy')?.r.error;
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  setBusy(on) {
    this._busy = on;
    this.parts.forEach((p) => p.querySelectorAll('[data-buy-btn],[data-ref="stickyBtn"]').forEach((b) => b.setAttribute('aria-busy', on ? 'true' : 'false')));
    this.renderAll();
  }

  routes() {
    const R = (typeof Theme !== 'undefined' && Theme.routes) || {};
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return { root, cart: R.cart_url || root + 'cart', add: R.cart_add_url || root + 'cart/add.js' };
  }

  openCart() {
    const drawer = document.querySelector('#cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      if (!drawer.isOpen) drawer.open();
      return true;
    }
    return false;
  }

  async addToCart(checkout, src) {
    const s = this.S[this.sel];
    if (this._busy || !s || !s.available || !s.variantId) return;
    const buy = this.first('buy');
    const L = Object.assign({}, this.L, buy?.L);
    if (this.design) {
      this.showError(`Editor preview: on the live page this adds ${s.id} to the cart. Test the cart in a normal browser tab.`);
      return;
    }
    const nav = checkout ? 'checkout' : (buy?.L.afterAdd || 'drawer');
    const { root, cart, add } = this.routes();
    this.showError('');
    this.setBusy(true);
    let ev = null, deferred = null;
    try {
      const current = await fetch(cart + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      if (current.items?.some((it) => it.variant_id === s.variantId)) {
        if (nav === 'checkout') { location.href = root + 'checkout'; return; }
        this.showError(`${s.id} ${L.errInCart}`);
        if (nav === 'cart' || !this.openCart()) location.href = cart;
        return;
      }

      const body = new FormData();
      body.append('id', String(s.variantId));
      body.append('quantity', '1');
      const ids = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
      if (ids.length) body.append('sections', ids.join(','));

      if (nav === 'drawer') {
        ev = await import('@shopify/events').catch(() => null);
        if (ev?.CartLinesUpdateEvent?.createPromise) {
          deferred = ev.CartLinesUpdateEvent.createPromise();
          src.dispatchEvent(new ev.CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: String(s.variantId), quantity: 1 }],
            promise: deferred.promise,
          }));
        }
      }

      const res = await fetch(add, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html' },
        body,
      }).then((r) => r.json());

      if (res.status) {
        if (deferred) {
          deferred.resolve({
            cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(current),
            detail: { didError: true, items: current.items, source: 'zen-landing', sourceId: src.id, itemCount: 1, productId: this.data.productId },
          });
        }
        this.showError(res.description || res.message || L.errAdd);
        return;
      }

      if (nav === 'checkout') { location.href = root + 'checkout'; return; }
      if (nav === 'cart' || !deferred) { location.href = cart; return; }
      const fresh = await fetch(cart + '.json', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      deferred.resolve({
        cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(fresh),
        detail: { items: fresh.items, source: 'zen-landing', sourceId: src.id, itemCount: 1, productId: this.data.productId, sections: res.sections, didError: false },
      });
      if (!this.openCart()) location.href = cart;
    } catch (err) {
      console.error('[zen]', err);
      deferred?.reject?.(err);
      this.showError(L.errNetwork);
    } finally {
      this.setBusy(false);
    }
  }

  /* Reviews: play a video in the large player. Without JS the links open YouTube. */
  revPlay(p, i, a) {
    const items = [...p.querySelectorAll('[data-rev]')];
    const it = items.find((x) => Number(x.dataset.i) === i) || (a && a.dataset.yt ? a : null);
    const screen = p.r.revScreen;
    if (!it || !screen || !it.dataset.yt) { if (it && it.href) window.open(it.href, '_blank', 'noopener'); return; }
    items.forEach((x) => { const on = x === it; x.classList.toggle('is-active', on); x.setAttribute('aria-current', on ? 'true' : 'false'); });
    const st = Number(it.dataset.start) || 0;
    let f = screen.querySelector('iframe');
    if (!f) {
      f = document.createElement('iframe');
      f.className = 'zen-rev__iframe';
      f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
      f.setAttribute('allowfullscreen', '');
      f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      screen.appendChild(f);
    }
    f.title = it.dataset.title || 'Video';
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(it.dataset.yt) + '?autoplay=1&rel=0&playsinline=1' + (st > 0 ? '&start=' + st : '');
    screen.classList.add('is-playing');
    if (p.r.revNo) p.r.revNo.textContent = pad2(i + 1);
    if (p.r.revTitle) p.r.revTitle.textContent = it.dataset.title || '';
    if (p.r.revChannel) p.r.revChannel.textContent = it.dataset.channel || '';
    const r = screen.getBoundingClientRect(), h = this.viewH || window.innerHeight;
    if ((r.top < 0 || r.bottom > h) && typeof this.scrollToEl === 'function') this.scrollToEl(screen);
  }

  /* In the box, Reviews: each tile rises in as it enters, sweeping left to right. */
  tickReveal(p, { vh }) {
    const els = p._rv || (p._rv = [...p.querySelectorAll('[data-rv]')]);
    const sec = p.r.box || p.r.rev;
    if (!els.length || !sec || !this.inView(sec, vh, 160)) return;
    const vw = window.innerWidth || 1;
    for (const el of els) {
      let k = 1;
      if (!this.reduced) {
        const r = el.getBoundingClientRect();
        k = ease(cl((vh * 0.97 - r.top) / (vh * 0.3) - (r.left / vw) * 0.45));
      }
      const t = k.toFixed(3);
      if (el._k !== t) { el._k = t; el.style.setProperty('--k', t); }
    }
  }

  inView(el, vh, m = 60) {
    const r = el.getBoundingClientRect();
    return r.bottom > -m && r.top < vh + m ? r : null;
  }

  tick(t) {
    const vh = this.viewH, y = this.scrollTop, now = t / 1000;
    const dt = this._lt ? Math.min(0.05, (t - this._lt) / 1000) : 0.016;
    this._lt = t;
    const vel = (y - (this._py ?? y)) / Math.max(dt, 0.001);
    this._py = y;
    const f = { vh, y, now, dt, vel };
    this.parts.forEach((p) => {
      const fn = TICKS[p.kind];
      if (!fn) return;
      try { this[fn](p, f); } catch (e) { if (!p._err) { p._err = true; console.error('[zen] ' + p.kind, e); } }
    });
  }

  tickHero(p, { vh, now }) {
    const hero = p.r.hero, hr = hero && this.inView(hero, vh);
    if (!hr) return;
    const stage = p.r.heroStage;
    const H = stage?.clientHeight || vh;
    const vw = stage?.clientWidth || window.innerWidth;
    const narrow = vw < 880;
    const pr = this.reduced ? 1 : pinOf(hr, H), st = hero.style;
    const rv = ease(cl(pr / 0.4));
    const s = ease(cl((pr - 0.4) / 0.4));
    const tilt = ease(cl((pr - 0.52) / 0.38));
    const fin = sm(0.72, 0.88, pr);
    let padW, padH;
    if (narrow) { padW = vw * 0.86; padH = padW / 1.1667; }
    else { padH = Math.min(H * 0.62, (vw * 0.5) / 1.1667); padW = padH * 1.1667; }
    const fw = lerp(vw, padW, s), fh = lerp(H, padH, s);
    const follow = this.mouse && fin > 0.5 && !this.reduced;
    const mx = follow ? this.mouse.x / window.innerWidth - 0.5 : 0;
    const my = follow ? this.mouse.y / window.innerHeight - 0.5 : 0;
    p._tx = lerp(p._tx || 0, mx, 0.07);
    p._ty = lerp(p._ty || 0, my, 0.07);
    const pulse = this.reduced ? 1 : 1 + 0.05 * Math.sin(now * 1.3);
    st.setProperty('--fw', fw.toFixed(1) + 'px');
    st.setProperty('--fh', fh.toFixed(1) + 'px');
    st.setProperty('--fx', lerp(0, narrow ? 0 : vw * 0.17, s).toFixed(1) + 'px');
    st.setProperty('--fy', lerp(0, narrow ? -H * 0.2 : H * 0.02, s).toFixed(1) + 'px');
    st.setProperty('--fr', (s * padW * 0.03).toFixed(1) + 'px');
    st.setProperty('--rx', (tilt * 16 - p._ty * 8).toFixed(2) + 'deg');
    st.setProperty('--ry', (p._tx * 12).toFixed(2) + 'deg');
    st.setProperty('--rz', (tilt * -2.5).toFixed(2) + 'deg');
    st.setProperty('--r', (lerp(0.1, 1.5, rv) * fw * pulse).toFixed(0) + 'px');
    st.setProperty('--shine', lerp(-32, 32, sm(0.58, 0.98, pr)).toFixed(2) + '%');
    st.setProperty('--edge', (s * 0.22).toFixed(3));
    st.setProperty('--pad', fin.toFixed(3));
    st.setProperty('--ta', (1 - sm(0.08, 0.18, pr)).toFixed(3));
    st.setProperty('--tb', (sm(0.2, 0.28, pr) * (1 - sm(0.42, 0.5, pr))).toFixed(3));
    st.setProperty('--tc', fin.toFixed(3));
    st.setProperty('--tbar', (1 - sm(0.5, 0.66, pr)).toFixed(3));
    p.r.heroContent?.classList.toggle('is-interactive', fin > 0.6);
    if (p.r.hint && !this.reduced) p.r.hint.style.transform = 'translateY(' + (((now * 30) % 48) - 12).toFixed(1) + 'px)';
  }

  tickStatement(p, { vh }) {
    const man = p.r.man, mr = man && this.inView(man, vh);
    if (!mr) return;
    const mp = this.reduced ? 1 : pinOf(mr, man.firstElementChild?.clientHeight || vh);
    man.style.setProperty('--mw', (cl((mp - 0.05) / 0.62) * (p.words + 1)).toFixed(2));
    man.style.setProperty('--ink', ease(cl((mp - 0.02) / 0.7)).toFixed(3));
    man.style.setProperty('--st', sm(0.7, 0.88, mp).toFixed(3));
  }

  tickStrip(p, { vh, dt, vel }) {
    const mq = p.r.mq;
    if (!mq || this.reduced || !this.inView(mq, vh, 200)) return;
    if (Math.abs(vel) > 2) p._dir = vel > 0 ? 1 : -1;
    const speed = 50 + Math.min(1800, Math.abs(vel)) * 0.35;
    p._mq = (p._mq || 0) + speed * dt * (p._dir || 1);
    const half = mq.scrollWidth / 2 || 1;
    const off = ((p._mq % half) + half) % half;
    mq.style.transform = 'translate3d(' + (-off).toFixed(1) + 'px,0,0)';
  }

  tickDetails(p, { vh }) {
    const gal = p.r.gal, tr = p.r.galTrack;
    if (!gal || !tr || !gal.classList.contains('is-track')) return;
    const gr = this.inView(gal, vh);
    if (!gr) return;
    if (p.galDist == null) this.layoutGallery(p);
    const gp = pinOf(gr, p.r.galViewport?.clientHeight || vh);
    tr.style.transform = 'translate3d(' + (-gp * (p.galDist || 0)).toFixed(1) + 'px,0,0)';
    gal.style.setProperty('--gp', gp.toFixed(4));
    const gc = p.r.galCount;
    if (gc) {
      const n = p.figs, i = Math.min(n, Math.floor(gp * n) + 1);
      const txt = pad2(i) + ' / ' + pad2(n);
      if (gc.textContent !== txt) gc.textContent = txt;
    }
  }

  tickBand(p, { vh }) {
    const band = p.r.band, br = band && this.inView(band, vh);
    if (!br) return;
    if (this.reduced) {
      if (!p._still) { p._still = true; ['--b1', '--b2', '--b3'].forEach((k) => band.style.setProperty(k, '0px')); band.style.setProperty('--bs', '1'); }
      return;
    }
    const vw = band.clientWidth, bp = viewOf(br, vh), k = bp - 0.5;
    band.style.setProperty('--bs', (1.22 - 0.22 * ease(bp)).toFixed(4));
    band.style.setProperty('--b1', (k * -vw * 0.3).toFixed(1) + 'px');
    band.style.setProperty('--b2', (k * vw * 0.22).toFixed(1) + 'px');
    band.style.setProperty('--b3', (k * -vw * 0.14).toFixed(1) + 'px');
  }

  tickSurfaces(p, { vh }) {
    const sf = p.r.surf, sr = sf && this.inView(sf, vh);
    if (!sr) return;
    const sp = pinOf(sr, sf.firstElementChild?.clientHeight || vh), s3 = sp * 3, ks = [];
    for (let i = 0; i < 3; i++) {
      const local = s3 - i;
      const fi = i === 0 ? 1 : sm(-0.08, 0.12, local);
      const fo = i === 2 ? 1 : 1 - sm(0.88, 1.08, local);
      const k = Math.max(0, Math.min(fi, fo));
      ks.push(k);
      sf.style.setProperty('--k' + i, k.toFixed(3));
      sf.style.setProperty('--y' + i, (this.reduced ? 0 : (1 - k) * 50 * (local < 0.5 ? 1 : -1)).toFixed(1) + 'px');
      sf.style.setProperty('--f' + i, cl(local).toFixed(3));
    }
    const step = Math.min(2, Math.max(0, Math.floor(s3)));
    const RR = this.ratings();
    KEYS.forEach((key, m) => sf.style.setProperty('--v' + m, (RR[step][key] / 5).toFixed(4)));
    for (let i = 0; i < 3; i++) sf.style.setProperty('--s' + i, i === step ? '1' : '0');
    sf.style.setProperty('--bz', (this.reduced ? 1.06 : 1.06 + sp * 0.18).toFixed(4));
    sf.style.setProperty('--br', (this.reduced ? 0 : -3 + sp * 6).toFixed(2) + 'deg');
    if (step !== this.step) {
      this.step = step;
      this.parts.forEach((q) => { if (q.kind === 'surfaces') this.renderStep(q); });
    }
  }

  tickBuy(p, { vh }) {
    const el = p.r.focus;
    if (!el) return;
    const r = el.getBoundingClientRect();
    if (r.bottom < -60 || r.top > vh + 60) return;
    const v = this.reduced ? 1 : cl((0.85 - r.top / vh) / 0.45);
    if (p._in !== v) { p._in = v; el.style.setProperty('--in', v.toFixed(3)); }
  }

  /* The count and the stock bars finish when the counter reaches the middle of the screen. */
  tickCount(p, { vh }) {
    const ed = p.r.ed, er = ed && this.inView(ed, vh);
    if (!er) return;
    const c = p.r.edCount;
    let e = 1;
    if (!this.reduced) {
      const cr = (c || ed).getBoundingClientRect();
      e = ease(cl((vh - (cr.top + cr.height / 2)) / (vh * 0.5)));
      ed.style.setProperty('--ey', ((viewOf(er, vh) - 0.5) * -70).toFixed(1) + 'px');
    }
    if (p._e !== e) {
      p._e = e;
      ed.style.setProperty('--ef', e.toFixed(4));
      if (c) {
        const txt = String(Math.max(1, Math.round(this.E * e))).padStart(3, '0');
        if (c.textContent !== txt) c.textContent = txt;
      }
    }
  }

  tickClosing(p, { vh }) {
    const fn = p.r.fin, fr = fn && this.inView(fn, vh);
    if (fr) fn.style.setProperty('--fs', this.reduced ? '1' : (1.28 - 0.28 * ease(cl(viewOf(fr, vh) / 0.8))).toFixed(4));
  }

  /* Shows once the Buy area has been scrolled past; hides when sold out and when the footer comes in. */
  tickSticky(p, { vh, y }) {
    const bar = p.r.sticky;
    if (!bar) return;
    let show = false;
    if (this.state === 'live') {
      /* Only after the visitor has scrolled past the Buy area, never before it. */
      const bz = this.first('buy')?.r.buy;
      if (bz) show = bz.getBoundingClientRect().bottom < 80;
      else show = y > vh;
      const f = show && this.footerEl();
      if (f && f.getBoundingClientRect().bottom < vh - 40) show = false;
    }
    if (show !== p._on) { p._on = show; bar.classList.toggle('is-visible', show); }
  }
}

let hub = null;
class ZenSection extends HTMLElement {
  connectedCallback() {
    if (!hub) hub = new ZenHub();
    /* Live site: move the sticky bar to <body> so no theme or app wrapper (transform, filter) can pin it inside the page. */
    if (this.dataset.part === 'sticky' && !(window.Shopify && window.Shopify.designMode) && this.parentNode !== document.body) {
      document.body.appendChild(this);
      return;
    }
    hub.attach(this);
  }
  disconnectedCallback() {
    if (hub) hub.detach(this);
  }
}
if (!customElements.get('zen-section')) customElements.define('zen-section', ZenSection);

/* Loading screen hooks (the screen itself lives in the Hero section). */
window.ZenLoader?.mark('scripts');
customElements.whenDefined('zen-section').then(() => requestAnimationFrame(() => requestAnimationFrame(() => window.ZenLoader?.mark('render'))));
